<template>
    <form-select
        :required="required"
        :error="error"
        name="active"
        :labelClasses="labelClasses"
        :inputHolderClasses="inputHolderClasses"
        label="active"
        :options="options"
        :value="internalValue"
        @input="handleInput"
    />
</template>
<script>
export default {
    name: 'active-select',
    props: {
        return: {
            type: String,
            required: false,
            default: 'id',
        },
        required: {
            type: Boolean,
            default: false,
        },
        value: {
            required: false,
            default: null,
        },
        error: {
            type: String,
            default: null,
        },
        labelClasses: {
            type: String,
            required: false,
        },
        inputHolderClasses: {
            type: String,
            required: false,
        },
    },
    data() {
        return {
            name: this.uLang('app.active'),
            internalValue: { name: this.uLang('app.active'), id: 1 },
            options: [
                { name: this.uLang('app.inactive'), id: 0 },
                { name: this.uLang('app.active'), id: 1 },
            ]
        }
    },
    watch: {
        value: {
            immediate: true,
            handler: function(newVal) {
                if (newVal != null && Number.isInteger(newVal)) {
                    this.internalValue = this.options.find((option) => { return option[this.return] == newVal})
                    return
                }

                this.internalValue = newVal
            }
        },
        internalValue(value) {
            if(value != null && (typeof value === 'object' || Array.isArray(value))) {
                return this.$emit('input', value[this.return])
            }
            
            return this.$emit('input', value)
        }
    },

    methods: {
        handleInput(event) {
            this.internalValue = event
        },
    }
}
</script>
